import { render, staticRenderFns } from "./EditRankData.vue?vue&type=template&id=4ea7d56c&scoped=true&"
import script from "./EditRankData.vue?vue&type=script&lang=js&"
export * from "./EditRankData.vue?vue&type=script&lang=js&"
import style0 from "./EditRankData.vue?vue&type=style&index=0&id=4ea7d56c&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea7d56c",
  null
  
)

export default component.exports